var _defs, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgProduct(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "22px",
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u5F62\u72B6\u5907\u4EFD 5") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "100%",
    y1: "58.7200081%",
    x2: "0%",
    y2: "58.7200081%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "currentColor",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "currentColor",
    stopOpacity: 0.698153409,
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "20220317\\u7ECF\\u8425\\u60C5\\u51B5\\u5C55\\u793A",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u753B\\u677F\\u5907\\u4EFD-46",
    transform: "translate(-663.000000, -359.000000)",
    fill: "url(#linearGradient-1)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-19",
    transform: "translate(646.000000, 113.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-31\\u5907\\u4EFD-2",
    transform: "translate(0.000000, 239.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4",
    transform: "translate(17.000000, 7.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4",
    transform: "translate(0.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.7855463,0 L11.7863512,9.63921951 C12.4020821,9.99497561 12.7023013,10.7199024 12.5179844,11.4067317 C12.3339359,12.093561 11.7112293,12.571122 11.0002546,12.571122 C10.2890116,12.571122 9.66657335,12.093561 9.4825248,11.4067317 C9.29847624,10.7199024 9.59842709,9.99497561 10.214158,9.63921951 L10.214107,6.35165109 C8.34736885,6.66677953 6.81688439,8.08475196 6.39769936,9.98370732 C5.92067557,12.1431951 7.00913763,14.344 9.01515952,15.2757805 C11.0209131,16.207561 13.4046906,15.6194634 14.7472256,13.861878 C16.0897605,12.1042927 16.0299313,9.64968293 14.6034209,7.95943902 C14.4167204,7.74568239 14.3598014,7.44785711 14.4545186,7.18031707 C14.5491185,6.91264552 14.7808668,6.71690567 15.060591,6.66841463 C15.3402391,6.61984656 15.6243397,6.72589725 15.8037608,6.94582927 C17.7059536,9.19921951 17.7856364,12.472122 15.9955899,14.8156585 C14.2055433,17.1591951 11.0270839,17.9431463 8.35247742,16.7009512 C5.67813928,15.4584878 4.22667767,12.5239024 4.86279883,9.64431707 C5.4414064,7.02397834 7.60689328,5.09033288 10.2142371,4.76340245 L10.214158,1.60278049 C5.37416405,2.00360976 1.57138829,6.05778049 1.57138829,11 C1.57138829,16.2070244 5.79296841,20.4286098 10.9999863,20.4286098 C16.2070042,20.4286098 20.4285844,16.2070244 20.4285844,11 C20.432317,8.66374877 19.5649747,6.41001423 17.9959776,4.67902439 C17.7172219,4.35573171 17.7478072,3.86904878 18.0646605,3.58278049 C18.3815137,3.29678049 18.8687326,3.31582927 19.1619762,3.62597561 C20.9917174,5.64574732 22.0034949,8.27466942 21.9999818,11 C21.9999818,17.0752195 17.0751983,22 10.9999863,22 C4.92504266,22 0,17.0752195 0,11 C0,4.92504878 4.92477436,0 10.9999863,0 L11.7855463,0 Z",
    id: "\\u5F62\\u72B6\\u7ED3\\u5408"
  })))))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProduct);
export default __webpack_public_path__ + "static/media/product.fa2f0203828e9839cb4f41febd788137.svg";
export { ForwardRef as ReactComponent };